import React from 'react';
import { Box, Typography } from '@mui/material';
import { ArrowUpward, ArrowDownward, UnfoldMore } from '@mui/icons-material';
import { SortField, Order } from '../types';

interface HeaderCellProps {
  children: React.ReactNode;
  sortField?: SortField;
  orderBy?: SortField;
  order?: Order;
  onSort?: (field: SortField) => void;
  align?: 'left' | 'right';
}

const HeaderCell: React.FC<HeaderCellProps> = ({
  children, sortField, orderBy, order, onSort, align = 'left',
}) => {
  const isActive = sortField && orderBy === sortField;
  const clickable = Boolean(sortField && onSort);

  return (
    <Box
      onClick={() => sortField && onSort?.(sortField)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
        gap: 0.5,
        cursor: clickable ? 'pointer' : 'default',
        userSelect: 'none',
        '&:hover': clickable ? { color: 'primary.main' } : {},
        width: '100%',
      }}
    >
      <Typography
        variant="caption"
        fontWeight={700}
        color={isActive ? 'primary.main' : 'text.secondary'}
        noWrap
        sx={{ fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: 0.3 }}
      >
        {children}
      </Typography>
      {clickable && (
        <Box sx={{ color: isActive ? 'primary.main' : 'text.disabled', display: 'flex', flexShrink: 0 }}>
          {isActive
            ? order === 'asc'
              ? <ArrowUpward sx={{ fontSize: 14 }} />
              : <ArrowDownward sx={{ fontSize: 14 }} />
            : <UnfoldMore sx={{ fontSize: 14 }} />
          }
        </Box>
      )}
    </Box>
  );
};

export default HeaderCell;
